/**
 * TOC
 */

// 目次
export function toc() {
  document.addEventListener("DOMContentLoaded", function() {
    const toc = document.querySelectorAll(".table-of-contents");

    if (toc.length > 0) {
      tocbot.init({
        tocSelector: '.table-of-contents',
        contentSelector: '.l-contents__inner',
        // headingSelector: 'h1, h2, h3',
        headingSelector: 'h2',
        ignoreSelector: '.toc-ignore', // スキップするclass
        hasInnerContainers: true,
        scrollSmooth: false,
        orderedList: false, // ul
      });
    }

  });
}
